import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import Select from '../../../components/Input/Select';
import { getCities, getStates } from '../../../services/commerce.service';
import { City, CommerceAddressState, State } from '../../../types/add_commerce.types';

export function AddressStateSelect({ disabled }: { disabled?: boolean }) {
  const { setFieldValue } = useFormikContext();
  const [states, setStates] = useState<Array<State>>([]);

  const fetchStates = async () => {
    const responseStates = await getStates();
    setStates(responseStates);
  };

  useEffect(() => {
    fetchStates();
  }, []);

  return (
    <Select
      className="col-md-6"
      name="stateId"
      label="Departamento"
      required
      disabled={disabled}
      handleOnChange={(targetValue) => {
        setFieldValue('stateId', targetValue);
        setFieldValue('cityId', '');
      }}
    >
      {states.map((state, index) => (
        <option key={index} value={state.id}>
          {state.name}
        </option>
      ))}
    </Select>
  );
}

export function AddressCitySelect({
  localState,
  disabled,
}: {
  localState: CommerceAddressState;
  disabled?: boolean;
}) {
  const [cities, setCities] = useState<Array<City>>([]);
  const { values } = useFormikContext<{ stateId: string }>();

  const fetchCities = async (stateId: number) => {
    const responseCities = await getCities(stateId);
    setCities(responseCities.data);
  };

  useEffect(() => {
    const stateId = values.stateId || localState?.city?.stateId;
    if (!stateId) return;
    fetchCities(+stateId);
  }, [values.stateId, localState?.city?.stateId]);

  return (
    <Select className="col-md-6" name="cityId" label="Localidad" required disabled={disabled}>
      {cities.map((city, index) => (
        <option key={index} value={city.id}>
          {city.name}
        </option>
      ))}
    </Select>
  );
}
